export const dateTimeFormats = {
  short: {
    year: "angka",
    month: "pendek",
    day: "angka"
  },
  long: {
    year: "angka",
    month: "pendek",
    day: "angka",
    weekday: "pendek",
    hour: "angka",
    minute: "angka",
    hour12: true
  }
};

export default {
  about_directus: "Mengenai Directus",
  activity: "Aktiviti",
  my_activity: "Aktiviti Saya",
  activity_log: "Log Aktiviti",
  activity_outside_directus: "Benda ini telah dicipta diluar Directus.",
  admin_email: "Email Pentadbir",
  admin_password: "Katalaluan Pentadbir",
  additional_info: "Maklumat Tambahan",
  add_new: "Tambah Baru",
  add_field_filter: "Tambah penapis medan",
  add_note: "Tambah nota berguna untuk pengguna...",
  admin_settings: "Tetapan Pentadbir",
  almost_done_options:
    "Hampir Selesai! Sekarang cuma perlu lihat semula pilihan antaramuka di bawah.",
  almost_done_copy:
    "Setiap antaramuka boleh disesuaikan dengan keperluan anda. Di bawah adalah pilihan yang tersedia untuk medan ini, tetapi hanya beberapa yang diperlukan.",
  all: "Semua",
  statuses: "Status-status",
  api_url: "API URL",
  api_installed: "API Berjaya Dipasang",
  auto_generate: "Menjana Secara Automatik",
  auto_generated: "Dijana secara automatik...",
  batch: "Kumpulan",
  batch_edit: "Sunting Benda-Benda Dalam Kumpulan: {collection}",
  batch_delete: "Padam Kumpulan",
  batch_delete_confirm:
    "Tiada benda dipilih | Adakah anda pasti ingin memadam benda ini? Tindakan ini tidak dapat dibatalkan. | Adakah anda pasti ingin memadam {count} benda ini? Tindakan ini tidak dapat dibatalkan.",
  between: "Diantara",
  both: "Kedua-duanya",
  bookmarks: "Penandabuku",
  cancel: "Batal",
  change_project: "Tukar Projek",
  choose_one: "Pilih Satu",
  choose_project: "Pilih Projek",
  choose_interface: "Pilih antaramuka untuk bagaimana data ini dikendalikan.",
  clear: "Bersihkan",
  click_to_toggle_all_none: "Klik untuk menghidupkan seluruh lajur hidup/mati",
  connection: "Sambungan",
  collection: "Koleksi",
  collections_and_fields: "Koleksi & Medan",
  collection_invalid_name: "Nama koleksi tidak sah",
  collection_updated: "{collection} Koleksi Dikemaskini",
  collection_removed: "{collection} Koleksi Dibuang",
  collection_names_cannot_be_changed:
    "Collection names cannot be edited at this time. Nama koleksi tidak dapat diedit buat masa ini.",
  collections: "Koleksi-koleksi",
  collection_count: "Tiada Koleksi | Satu Koleksi | {count} Koleksi",
  "collections-directus_files": "Fail-fail",
  "collections-directus_users": "Pengguna-pengguna",
  "collections-directus_activity": "Aktiviti",
  comment: "Komen",
  comments: "Komen-komen",
  coming_soon: "Akan Datang",
  contains: "Mengandungi",
  config_error: "Konfigurasi Hilang",
  config_error_copy: "Pastikan anda telah membuat fail konfigurasi aplikasi",
  collection_contains_items: "{collection} mengandungi {count} benda",
  currently_selected: "Sedang dipilih: {thing}",
  create: "Cipta",
  creating_item: "Membuat Benda",
  creating_item_page_title: "Mencipta Benda: {collection}",
  creating_role: "Mewujudkan Peranan",
  create_role: "Buat Peranan",
  create_field: "Cipta Medan",
  update_field: "Kemaskini Medan",
  create_collection: "Cipta Koleksi",
  database_connection: "Sambungan Pangkalan Data",
  database_connection_copy:
    "Seterusnya, kita perlu tahu bagaimana untuk menyambung ke pangkalan data di mana projek ini akan diuruskan.",
  datatype: "Jenis data",
  db_datatype: "Jenis data {db}",
  editing_my_profile: "Sunting Profail Saya",
  embed: "Benamkan",
  embed_placeholder: "YouTube, Vimeo, atau pautan lain",
  fieldtypes: {
    alias:
      "Medan yang tidak menyimpan data atau tidak mempunyai lajur pangkalan data yang sepadan",
    array: "Respon API dalam format tatasusunan standard",
    datetime:
      "Tarikh dan masa dalam format ISO, contoh: 2018-09-19T14:00:43.381Z",
    date: "Tarikh, contoh: 2018-09-19",
    time: "Masa, contoh: 14:09:22",
    file: "Kunci asing ke directus_files.id",
    group:
      "Kumpulkan medan secara visual, kumpulan kanak-kanak tersimpan ke dalam directus_fields.group",
    integer: "Nombor bulat",
    decimal: "Nombor yang ada perpuluhan",
    json:
      "Standard JSON format in API response Respons API dalam format JSON standard",
    lang: "Khusus untuk antaramuka penterjemahan, ini menyimpan kekunci bahasa",
    m2o: "Hubungan Ramai-ke-Satu",
    o2m: "Hubungan Satu-ke-Ramai",
    sort:
      "Medan sistem yang digunakan dalam menyusun semula benda seret-dan-lepas",
    status: "Medan sistem yang digunakan untuk menerbitkan aliran kerja",
    string:
      "Apa-apa teks, nombor, ruang, atau simbol; ditakrifkan dan dihadkan oleh panjangnya (bilangan aksara)",
    translation:
      "Khusus untuk antaramuka penterjemahan, o2m ini menyimpan kandungan pelbagai bahasa",
    uuid: "Pengenal pasti unik universal",
    datetime_created:
      "Medan sistem untuk menjejaki tarikhmasa benda yang dibuat, digunakan untuk semakan",
    datetime_updated:
      "Medan sistem untuk menjejaki tarikhmasa benda yang dikemasikini, digunakan untuk semakan",
    user_created:
      "Medan sistem untuk menjejaki siapa yang mencipta setiap benda, digunakan untuk semakan",
    user_updated:
      "Medan sistem untuk menjejaki siapa yang mengemaskini setiap benda, digunakan untuk semakan"
  },
  datatypes: {
    mysql: {
      CHAR:
        "Perkataan/Ayat bukan-binari yang panjangnya tetap dan mempunyai jarak pada akhir perkataan. Panjang karakter boleh diantara 0 hingga 255.",
      VARCHAR:
        "Perkataan/Ayat bukan-binari yang panjangnya tidak tetap. Panjang karakter boleh diantara 0 hingga 255 (MySQL 5.0.3+).",
      TINYTEXT: "Perkataan/Ayat dengan panjang maksimum sebanyak 255 karakter.",
      TEXT: "Perkataan/Ayat dengan panjang maksimum sebanyak 65,535 karakter.",
      MEDIUMTEXT:
        "Perkataan/Ayat dengan panjang maksimum sebanyak 16,777,215 karakter.",
      LONGTEXT:
        "Perkataan/Ayat dengan panjang maksimum sebanyak 4,294,967,295 karakter.",

      BOOLEAN: "Betul atau salah. Disimpan sama ada 1 atau 0.",
      TINYINT:
        "Integer. Apabila ditandatangani (membenarkan negatif) ialah -128 hingga 127, jika tidak maksima ialah 255.",
      SMALLINT:
        "Integer. Apabila tanda yang ditandatangani (membenarkan negatif) ialah -32,768 hingga 32,767, jika tidak, maksimum ialah 65,535.",
      MEDIUMINT:
        "Integer. Apabila ditandatangani (membenarkan negatif) ialah -8,388,608 hingga 8,388,607, jika tidak, maksimum ialah 16,777,215.",
      INT:
        "Integer. Apabila ditandatangani (membenarkan negatif) adalah -2,147,483,648 kepada 2,147,483,647, jika tidak, maksimum ialah 4,294,967,295.",
      BIGINT:
        "Integer. Apabila ditandatangani (membenarkan negatif) ialah -9,223,372,036,854,775,808 hingga 9,223,372,036,854,775,807, jika tidak, maksimum adalah 18,446,744,073,709,551,615.",

      DECIMAL:
        "Nombor yang tepat (misalnya: untuk mata wang), dengan panjang 1 hingga 65 digit (L) dan 0 hingga 30 digit perpuluhan (D). Format panjang: `L, D`",
      FLOAT:
        "Nombor binari secara anggaran, 4 bait dengan titik perpuluhan terapung.",
      DOUBLE:
        "Nombor binari secara anggaran, 8 bait dengan titik perpuluhan terapung.",

      DATE: "Tarikh. Dibenarkan `1000-01-01` hingga `9999-12-31`.",
      DATETIME:
        "Tarikh dan masa. Dibenarkan `1000-01-01 00:00:00` hingga `9999-12-31 23:59:59`.",
      TIMESTAMP:
        "Tarikh dan masa. Dibenarkan `1970-01-01 00:00:01` UTC hingga `2038-01-19 03:14:07` UTC.",
      TIME: "Masa. Dibenarkan `-838:59:59` hingga `838:59:59`.",
      YEAR: "Tahun. Dibenarkan `1901` hingga `2155` atau `0000`"
    }
  },
  date_and_time: "Tarikh & Masa",
  db_user: "Pengguna Pangkalan Data",
  db_password: "Kata Laluan Pengguna Pangkalan Data",
  db_name: "Nama Pangkalan Data",
  db_type: "Jenis Pangkalan Data",
  db_column_name: "Nama lajur pangkalan data...",
  db_updated: "Pangkalan data berjaya dikemaskini",
  db_update_failed: "Pangkalan data tidak dapat dikemaskini.",
  default: "Lalai",
  delete: "Padam",
  delete_are_you_sure:
    "Adakah anda pasti ingin memadam benda ini? Tindakan ini tidak dapat dibatalkan.",
  delete_collection_are_you_sure:
    "Adakah anda pasti ingin memadam koleksi ini? Tindakan ini tidak dapat dibatalkan.",
  delete_field_are_you_sure:
    'Adakah anda pasti ingin memadam medan "{field}"? Tindakan ini tidak dapat dibatalkan.',
  delete_role_are_you_sure:
    'Adakah anda pasti ingin memadam peranan "{name}"? Tindakan ini tidak dapat dibatalkan.',
  delete_bookmark: "Padam Penanda Buku",
  delete_bookmark_body:
    "Adakah anda pasti ingin memadam penanda buku ini? Tindakan ini tidak dapat dibatalkan.",
  description: "Penerangan",
  delete_confirmation: "Pengesahan untuk Padam",
  dialog_beginning: "Permulaan bagi tetingkap dialog",
  discard_changes: "Buang Perubahan",
  display_name: "Paparkan Nama",
  drop_files:
    "Tidak Dapat Lepaskan Fail-Fail | Lepaskan fail disini |  Lepaskan fail-fail disini...",
  dont_show: "Sembunyikan",
  editing: "Menyunting Benda: {collection}",
  editing_item: "Menyunting Benda",
  editing_items: "Menyunting Secara Kumpulan Sebanyak {count} Benda",
  editing_single: "Menyunting {collection}",
  email_address: "Alamat Emel",
  email: "Emel",
  empty_collection: "Koleksi Kosong",
  empty_collection_body: "Tiada benda dalam koleksi ini lagi",
  enable_manual_sorting: "Dayakan penyusun manual",
  enter_value: "Masukkan Nilai",
  enter_collection_name: "Masukkan nama koleksi...",
  enter_role_name: "Masukkan nama peranan...",
  environment: "Persekitaran",
  project_key: "Kunci Project",
  errors: {
    "-1": "Tidak dapat mencapai API",
    11: "Tidak dapat menyambung ke pangkalan data",
    100: "Nama pengguna dan/atau kata laluan salah",
    101: "Dilog keluar kerana ketiadaan aktiviti",
    102: "Dilog keluar kerana ketiadaan aktiviti",
    103: "Pengguna tidak aktif",
    106: "Nama pengguna dan/atau kata laluan salah",
    107: "Pengguna tidak dijumpai"
  },
  error_unknown: "Ralat tidak diketahui. Cuba lagi nanti.",
  esc_cancel: "Keluar akan membatalkan dan menutup tetingkap.",
  equal_to: "Sama dengan",
  existing: "Sedia ada",
  fetching_data: "Mengambil Data",
  field: "Medan",
  field_type: "Jenis Medan",
  field_created: "{field} Medan Dicipta",
  field_updated: "{field} Medan Dikemaskini",
  field_removed: "{field} Medan Dibuang",
  fields: "Medan-medan",
  fields_are_saved_instantly: "Perubahan disimpan dengan serta-merta",
  file: "Fail",
  file_library: "Perpustakaan Fail",
  file_upload: "Muatnaik Fail",
  forgot_password: "Lupa Katalaluan",
  greater_than_equal: "Lebih daripada atau sama dengan",
  greater_than: "Lebih daripada",
  help_and_docs: "Bantuan & Dokumentasi",
  keep_editing: "Terus Menyunting",
  hidden_detail: "Tersembunyi di Butiran",
  hidden_browse: "Tersembunyi ketika Dilayari",
  host: "Hos",
  in_list: "Salah satunya",
  initial_schema: "Pilih Skema Awal",
  initial_schema_copy:
    "Pilih daripada senibina pangkalan data sedia ada atau mula dari kosong. Anda sentiasa boleh melanjutkan dan ubahsuai ini kemudian.",
  interface: "Antaramuka",
  interface_count: "Tiada antaramuka | Satu Antaramuka | {count} Antaramuka",
  interfaces: "Antaramuka-antaramuka",
  info: "Info",
  intelligent_defaults:
    "Pilihan lanjutan membolehkan anda mengkonfigurasi bagaimana data akan disimpan dalam pangkalan data dan ubahsuai tetapan aplikasi tambahan.",
  interface_settings:
    "Setiap antara muka boleh disesuaikan dengan keperluan anda. Berikut ialah pilihan yang ada untuk antara muka ini, tetapi hanya beberapa yang diperlukan.",
  install: "Pasang",
  install_copy:
    "API ini belum disediakan lagi. Adakah anda ingin memasang dan mengkonfigurasinya sekarang?",
  is_empty: "Kosong",
  is_not_null: "Bukan NULL",
  is_null: "NULL",
  item_count: "Tiada Benda | Satu Benda | {count} Benda",
  event_count: "tiada Peristiwa | Satu Peristiwa | {count} Peristiwa",
  role_count: "Tiada Peranan | Satu Peranan | {count} Peranan",
  item_count_filter:
    "Tiada Benda yang Ditapis | Satu Benda Ditapis | {count} Benda Ditapis",
  item_deleted: "Benda telah dipadam",
  item_saved: "Benda telah disimpan | {count} Benda telah disimpan",
  junction_collection: "Koleksi Persimpangan",
  cant_disable_primary:
    "Anda tidak boleh melumpuhkan kunci primer pada medan yang ada. Keluarkan medan ini.",
  extension_error: "Terdapat masalah memuatkan sambungan {ext}.",
  extensions_missing: "Tiada Sambungan Dijumpai",
  extensions_missing_copy: "Pastikan anda telah memasang sambungan sistem.",
  latency: "Kependaman",
  learn_more: "Ketahui lebih lanjut",
  leave_comment: "Tinggalkan komen...",
  length: "Panjang",
  length_disabled_placeholder: "Panjang ditentukan oleh jenis data",
  less_than_equal: "Kurang daripada atau sama dengan",
  less_than: "Kurang daripada",
  limited: "Terhad",
  loading: "Memuatkan...",
  loading_more: "Memuatkan lebih banyak benda...",
  login: "Log masuk",
  m2m: "Ramai-ke-Ramai (M2M)",
  m2o: "Ramai-ke-Satu (M2O)",
  o2m: "Satu-ke-Ramai (O2M)",
  name: "Nama",
  name_field:
    "Jom namakan medan {field} dan tambahkan nota yang berguna untuk pengguna.",
  navigate_changes:
    "Adakah anda pasti mahu meninggalkan halaman ini? Perubahan yang anda buat akan hilang jika anda menavigasi dari halaman ini.",
  new: "Baru",
  new_file: "Fail Baru",
  no_related_entries: "Tiada catatan yang berkaitan",
  not_between: "Bukan Diantara",
  not_contains: "Tidak mengandungi",
  note: "Nota",
  note_note: "Keterangan dalaman...", //
  note_hidden:
    "[Ketahui lebih lanjut](https://docs.directus.io/guides/collections.html#hidden)",
  note_icon: "Ikon yang dipaparkan dalam bar sisi navigasi aplikasi",
  note_managed:
    "[Ketahui lebih lanjut](https://docs.directus.io/guides/collections.html#managing-collections)",
  note_single:
    "[Ketahui lebih lanjut](https://docs.directus.io/guides/collections.html#single)",
  no_results: "Tiada keputusan",
  no_results_body:
    "Penapis semasa tidak sepadan dengan sebarang benda dalam koleksi",
  no_collections: "Tiada Persediaan Koleksi",
  no_collections_body: "Nampaknya belum ada persediaan koleksi lagi",
  no_fields: "Tiada Persediaan Medan",
  no_fields_body: "Nampaknya koleksi ini tidak mempunyai persediaan medan lagi",
  no_files: "Fail Tiada",
  no_files_body: "Nampaknya belum ada sebarang fail yang dimuat naik lagi",
  numeric: "Angka",
  page_not_found: "Halaman Tidak Dijumpai",
  page_not_found_body: "Halaman yang anda cari tidak wujud",
  permissions: "Kebenaran",
  name_bookmark: "Apakah nama yang anda ingin letak untuk penanda buku ini?",
  next: "Kemudian",
  none: "Tiada",
  not_empty: "Bukan Kosong",
  not_equal_to: "Tidak sama dengan",
  not_in_list: "Bukan salah satu daripada ini",
  no_interface_error: "Medan {field} tidak mempunyai persediaan antara muka",
  manage: "Mengurus",
  manage_started: "Mula Mengurus {collection}",
  manage_stopped: "Berhenti Mengurus {collection}",
  max_size: "Saiz Maks.: {size}",
  max_one_primary_key:
    "Anda hanya boleh mempunyai 1 medan utama utama untuk setiap kumpulan",
  dont_manage: "Jangan Urus",
  dont_manage_copy:
    "Keistimewaan, keutamaan, dan tetapan untuk koleksi {koleksi} akan dikeluarkan secara kekal dari sistem! Adakah anda pasti?",
  more_options: "Lebih banyak pilihan",
  mixed: "Bercampur",
  my_profile: "Profail Saya",
  other: "Lain-lain",
  ok: "OK",
  operator: "Operator",
  open_on_gh: "Buka di GitHub",
  options: "Pilihan-pilihan",
  password: "Katalaluan",
  password_reset_sent: "Emel reset katalaluan dihantar ke {email}",
  permissions_no_collections:
    "Projek ini tidak mempunyai sebarang koleksi lagi.",
  permissions_admin:
    "Pentadbir mempunyai akses kepada semua data terurus dalam sistem secara lalai.",
  permission_states: {
    none: "Tiada",
    mine: "Kepunyaan Saya Sahaja",
    role: "Peranan Sahaja",
    full: "Semua",
    read: "Baca Sahaja",
    create: "Cipta",
    on_create: "Apabila Dicipta",
    update: "Kemaskini",
    on_update: "Apabila Dikemaskini",
    always: "Sentiasa"
  },
  popular: "Popular",
  powered_by_directus: "Dikuasakan oleh Directus",
  preview_and_revert: "Pratonton dan Kembalikan",
  primary_key: "Kunci Utama",
  port: "Port",
  project: "Projek",
  project_name: "Nama Projek",
  project_info: "Project Information",
  project_info_copy:
    "Berikut adalah beberapa soalan mengenai projek anda, termasuk kelayakan pentadbir pertama anda.",
  read: "Baca",
  readable_fields: "Medan Boleh Baca",
  readable_fields_copy: "Pilih medan-medan yang pengguna boleh lihat",
  readonly: "Lihat sahaja",
  relational: "Hubungan",
  report_issue: "Laporkan Isu",
  request_feature: "Minta Ciri",
  regex: "RegEx",
  relation_setup:
    "Oleh kerana ini adalah medan hubungan, kita perlu memetakan medan yang berkaitan.",
  relation_setup_copy:
    "Terdapat pelbagai jenis data hubungan, antara muka ini menggunakan satu yang dipanggil {relation}.",
  related_entries: "Ada catatan berkaitan",
  related_collection: "Koleksi Berkaitan",
  remove: "Buang",
  remove_related: "Buang Benda Berkaitan",
  relationship: "Perhubungan",
  required: "Diperlukan",
  reset_preferences: "Tetapkan semula semua pilihan penyenaraian",
  reset_password: "Tetapkan Semula Katalaluan",
  revert: "Kembalikan",
  revert_copy:
    "Adakah anda ingin kembalikan benda ini semula seperti pada {date}?",
  roles: "Peranan-peranan Pengguna",
  role_settings: "Tetapan Peranan",
  save: "Simpan",
  save_and_add: "Simpan dan Tambah Baru",
  save_and_stay: "Simpan dan Tetap Disini",
  save_as_copy: "Simpan sebagai Salinan",
  save_as_bookmark: "Simpan sebagai Penanda Buku",
  schema: "Skema",
  search: "Cari",
  select_from_device: "Pilih daripada peranti",
  select_existing: "Pilih yang sedia ada",
  select_field: "Pilih medan",
  select_fields: "Pilih medan-medan",
  search_interface: "Cari antaramuka...",
  select_interface_below: "Pilih antaramuka dibawah",
  select_statuses: "Pilih status-status",
  select_statuses_copy: "Pilih status-status yang pengguna boleh pakai",
  settings: "Tetapan",
  settings_project: "Tetapan Projek",
  settings_global: "Tetap Global",
  settings_update_database: "Kemaskini Pangkalan Data",
  settings_update_database_subtext: "Jalankan Skrip",
  settings_update_database_confirm:
    "Ini akan mengemas kini medan sistem dalam pangkalan data anda kepada versi terbaru Directus. Sila pastikan untuk membuat sandaran sebelum anda menjalankan operasi ini.",
  settings_collections_fields:
    "Collections & Fields Koleksi-koleksi & Medan-medan",
  settings_permissions: "Peranan-peranan & Kebenaran",
  settings_extensions: "Sambungan",
  settings_saved: "Settings Saved Tetapan Disimpan",
  server_details: "Butiran Pelayan",
  server_error: "Ralat Pelayan",
  server_error_copy:
    "Sesuatu yang salah dengan pelayan atau pangkalan data ini.",
  server_trouble: "Masalah Pelayan",
  server_trouble_copy: "Cuba lagi kemudian atau hubungi pentadbir sistem anda.",
  advanced_options: "Pilihan lanjutan",
  show_directus_collections: "Tunjukkan Koleksi Sistem Directus",
  something_went_wrong: "Ada yang salah.",
  something_went_wrong_body:
    "Terdapat masalah untuk memproses permintaan. Cuba lagi selepas menyegarkan halaman.",
  sort_by: "Disusun mengikut",
  sign_in: "Masuk",
  signing_in: "Cuba Masuk",
  sign_out: "Keluar",
  sign_out_confirm: "Adakah anda pasti ingin keluar?",
  sign_out_confirm_edits:
    "Adakah anda pasti ingin keluar? Semua perubahan yang tidak disimpan akan hilang.",
  text: "Teks",
  this_collection: "Koleksi Ini",
  to: "Kepada",
  unsaved_changes_copy:
    "Anda mempunyai perubahan yang belum disimpan! Adakah anda pasti mahu meninggalkan halaman ini?",
  user_directory: "Direktori pengguna",
  update: "Kemaskini",
  update_confirm: "Adakah anda pasti mahu mengemas kini {count} benda ini?",
  unique: "Unik",
  user_edit_warning:
    "{first_name} {last_name} sedang mengedit item ini. Sila berhubung dengan mereka supaya anda tidak kehilangan perubahan anda.",
  value: "Nilai",
  values: "Nilai-nilai",
  validation: "Pengesahan",
  version: "Versi",
  version_and_updates: "Versi dan Kemaskini",
  view_type: "Lihat Sebagai...",
  welcome: "Selamat Datang",
  writable_fields: "Medan-medan yang boleh ditulis",
  writable_fields_copy: "Pilih medan-medan yang pengguna boleh sunting",
  yes: "Ya",
  duplicating_field: "Medan Penduaan",
  duplicate: "Pendua",
  upload_exceeds_max_size:
    "{filename} tidak boleh dimuat naik. Pelayan anda tidak dikonfigurasi untuk mengendalikan saiz muat naik ini."
};
